import React from 'react';

import { SelectDivider } from '../Select.Divider';
import { SelectLabel } from '../Select.Label';

import styles from './Select.Section.module.scss';

export interface ISelectSectionProps {
  /** The text to be displayed on the label. */
  text: string;
  /** The indentation level of this label. Should be a number between 0 and 4. */
  indentLevel?: number;
}

export const SelectSection: React.SFC<ISelectSectionProps> = (props) => (
  <div>
    <SelectDivider />
    <div className={styles.label}>
      <SelectLabel text={props.text} indentLevel={props.indentLevel} />
    </div>
  </div>
);

SelectSection.defaultProps = {
  indentLevel: 0
};
